<template>
  <DragPanel title="动画设置" :closePanel="closePanel" :tooltipVisible="false">
    <div class="anim-seting-container" ref="containerRef">
      <div class="common-switch-box">
        <div class="label-box dialog-label">动画播放：</div>
        <div class="common-switch-box">
          <el-switch
          class="switch-primary"
            v-model="componentInfo.enableAnimationPlay"
            @change="handleSwitchChange"
          />
          <div class="switch-name-box dialog-label">
            {{ componentInfo.enableAnimationPlay ? "开启" : "关闭" }}
          </div>
        </div>
      </div>
      <div class="common-radio-box">
        <div class="label-box dialog-label">播放方式：</div>
        <el-radio-group
          v-model="componentInfo.playMode"
          @input="handleRadioInput"
          class="radio-primary"
        >
          <div
            class="radio-box"
            v-for="(item, index) in animPlayModeList"
            :key="index"
          >
            <el-radio :label="item.value">{{ item.label }}</el-radio>
          </div>
        </el-radio-group>
      </div>
    </div>
  </DragPanel>
</template>

<script>
import DragPanel from "@/components/CustomDragPanel.vue";

import { motifyElemAnimState, motifyElemAnimMode } from "@/service/interface";

export default {
  data() {
    return {
      componentInfo: {},
      animPlayModeList: [
        {
          value: "REPEAT",
          label: "播放到边界处时方向不变，从另一边界处继续播放",
        },
        { value: "REPEATTURN", label: "播放到边界处时方向调转继续播放" },
        { value: "ONCE", label: "播放到边界处时停止，位置/方向保持不变" },
        { value: "ONCETURN", label: "播放到边界处时停止，位置不变，方向调转" },
        {
          value: "ONCERESET",
          label: "播放到边界处时停止，位置移到另一边界，方向不变",
        },
      ],
    };
  },
  props: {
    currEntity: Object,
    closeAnimSettingPanel: Function,
  },
  components: { DragPanel },
  mounted() {
    this.componentInfo = this.currEntity.componentInfo;
  },
  methods: {
    handleSwitchChange(value) {
      let componentInfo = this.componentInfo;
      let params = { nodeId: componentInfo.id, playStatus: value };
      motifyElemAnimState(params).then((response) => {
        if (response.isSuccess) {
          let playMode = componentInfo.playMode;
          this.setAnimPlayMode(value, playMode);
          this.$message.success(`${value ? "打开" : "关闭"}构件动画成功`);
        } else {
          this.$message.error(response.errMsg);
        }
      });
    },
    handleRadioInput(value) {
      let componentInfo = this.componentInfo;
      let params = { nodeId: componentInfo.id, playMode: value };
      motifyElemAnimMode(params).then((response) => {
        if (response.isSuccess) {
          let enableAnimationPlay = componentInfo.enableAnimationPlay;
          this.setAnimPlayMode(enableAnimationPlay, value);
          this.$message.success("更改动画播放方式成功");
        } else {
          this.$message.error(response.errMsg);
        }
      });
    },
    setAnimPlayMode(enableAnimationPlay, playMode) {
      const BlackHole3D = window.BlackHole3D;
      let animPlayInfo = new BlackHole3D.REEntityAnimPlayInfo();
      let dataSetId = this.currEntity.srcDataSetId;
      dataSetId = dataSetId.replaceAll("-", "");
      animPlayInfo.dataSetId = dataSetId;
      let typeNames = BlackHole3D.Entity.getAllTypeNames(dataSetId);
      animPlayInfo.entityType = typeNames[0];
      animPlayInfo.elemIdList = [this.currEntity.elemId];

      const AnimPlayModeEm = BlackHole3D.REEntityAnimPlayModeEm;
      const AnimPlayStateEm = BlackHole3D.REEntityAnimPlayStateEm;
      animPlayInfo.animPlayMode = AnimPlayModeEm[playMode];
      if (enableAnimationPlay) {
        animPlayInfo.animPlayState = AnimPlayStateEm.PLAY;
      } else {
        animPlayInfo.animPlayState = AnimPlayStateEm.PAUSE;
      }

      BlackHole3D.Entity.setAnimPlayMode(animPlayInfo);
    },
    closePanel() {
      this.closeAnimSettingPanel();
    },
    // 打开其他面板前给出提示
    openOtherPanelCheck() {
      return new Promise((resolve) => {
        this.closeAnimSettingPanel();
        resolve(true);
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/publishSearch.less";

.radio-primary{
  display: flex;
  flex-direction: column;

  .radio-box{
    margin-bottom: 12px !important;
    :deep(.el-radio__label){
      font-size: 12px;
    }
  }
}
.common-drag-panel {
  left: 6px;
  top: 6px;
  width: 400px;
  height: unset;
  min-width: 400px;
  min-height: 250px;

  .anim-seting-container {
    padding: 15px;
    text-align: left;
    font-size: 14px;
    color: var(--default-color);

    .label-box {
      width: 70px;
      line-height: 16px;
      font-size: 14px;
      flex-shrink: 0;
    }

    .common-switch-box {
      display: flex;
      align-items: center;

      .switch-name-box {
        margin-left: 10px;
      }
    }

    .common-radio-box {
      display: flex;
      margin-top: 10px;

      // .radio-box {
      //   margin: 15px 0px;

      //   &:first-child {
      //     margin-top: 2px;
      //   }

      //   &:last-child {
      //     margin-bottom: 0px;
      //   }

      //   /deep/ .el-radio__label {
      //     font-size: 12px;
      //   }
      // }
    }
  }
}
</style>